var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-footer py-3"},[_c('div',{staticClass:"container text-footer-color"},[_vm._v(" © "+_vm._s(_vm.currentYear)+" "+_vm._s(_vm.selectedCompanyName)+". All rights reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }